import { render, staticRenderFns } from "./PocketsSidebar.vue?vue&type=template&id=4448a79c&scoped=true&"
import script from "./PocketsSidebar.vue?vue&type=script&lang=js&"
export * from "./PocketsSidebar.vue?vue&type=script&lang=js&"
import style0 from "./PocketsSidebar.vue?vue&type=style&index=0&id=4448a79c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4448a79c",
  null
  
)

export default component.exports